var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.23 145.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#383c3f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.12,144.46A72.71,72.71,0,0,0,145,78.56a5.21,5.21,0,0,1,.21-1.1.17.17,0,0,1,0-.1v-9c-.11-.84-.21-1.67-.31-2.51-.22-1.88-.43-3.66-.8-5.42C137.9,30.33,120.3,11,91.81,3,65.43-4.38,41.71,1.86,21.32,21.56,9.46,33,2.46,47.42.5,64.38c-4.18,36.27,18.27,69.36,53.39,78.67a77.13,77.13,0,0,0,8.81,1.62c1.44.21,2.89.42,4.32.66l1,.19h9.17l2.48-.32C81.44,145,83.31,144.78,85.12,144.46Zm-12.43-6.57h-.22a65,65,0,0,1,.06-130h.22a65,65,0,0,1-.06,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.81,65.09a4.2,4.2,0,0,0-4.08-4.3h-.07A4,4,0,0,0,69.79,62a4.37,4.37,0,0,0-1.29,3.15v39.57a5.29,5.29,0,0,0,.56,2.23,4,4,0,0,0,4.52,2,4.16,4.16,0,0,0,3.26-4.14V79.23Q76.84,72.16,76.81,65.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.63,36.56h0a6.35,6.35,0,1,0,0,12.7h0a6.35,6.35,0,0,0,0-12.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.750317927837c97de3e366eef6dd32d8.svg";
export { ForwardRef as ReactComponent };